import { Card } from '@mui/material'
import Typography from '@mui/material/Typography'
import LinearProgress, {
	linearProgressClasses,
} from '@mui/material/LinearProgress'
import { CompleteProfileModal } from './CompleteProfileModal'
import styles from '../../settingsTabs/venderSettingTabs.module.scss'
import ButtonCustom from '../../atoms/button/ButtonCustom'

export const VendorCompleteProfile = ({
	formData,
	setFormData,
	handleFileChange,
	modalOpen,
	setModalOpen,
	modalStep,
	setModalStep,
}) => {
	// Use props instead of local state to prevent reset on parent re-renders
	const open = modalOpen
	const setOpen = setModalOpen
	const step = modalStep
	const setStep = setModalStep

	const handleOpen = () => {
		setOpen(true)
	}
	const handleClose = () => {
		setOpen(false)
	}

	const profileCompleted = formData?.profileCompleted === true
	const progressValue = profileCompleted
		? 100
		: Math.min(Math.max((step - 1) * (100 / 7), 0), 100)

	return (
		<Card variant="outlined" className={styles.venderCompleteProfile}>
			<CompleteProfileModal
				open={open}
				handleClose={handleClose}
				handleFileChange={handleFileChange}
				formData={formData}
				setFormData={setFormData}
				step={step}
				setStep={setStep}
			/>

			<Typography variant="h6" className={styles.completeProfileTitle}>
				Complete your profile
			</Typography>
			<LinearProgress
				variant="determinate"
				value={progressValue}
				sx={{
					padding: '0.5rem',
					borderRadius: '1rem',
					backgroundColor: '#DFE4EB',
					[`& .${linearProgressClasses.bar}`]: {
						backgroundColor: '#7CA6BD',
						borderRadius: '50px',
					},
				}}
			/>
			<div className={styles.getStartRow}>
				<Typography variant="h6">
					{Math.round(progressValue)} % complete
				</Typography>
				<ButtonCustom variant="default" onClick={handleOpen}>
					{step === 0 ? 'Get Started →' : 'Continue →'}
				</ButtonCustom>
			</div>
		</Card>
	)
}
